import React, { useState, useEffect, useRef } from "react";
import qs from "qs";
import { useLocation, useHistory } from "react-router-dom";
import {
  InstantSearch,
  Configure,
  connectRefinementList,
  Highlight,
  connectSearchBox,
  connectCurrentRefinements,
  connectStats,
  connectSortBy,
  Pagination,
  connectHits,
  ScrollTo,
} from "react-instantsearch-dom";
import StickyBox from "react-sticky-box/dist/esnext";
import algoliasearch from "algoliasearch/lite";
import { CloseOutlined, LeftOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Typography,
  Collapse,
  Space,
  Checkbox,
  Badge,
  Button,
  Input,
  Select,
} from "antd";
import { MdSort } from "react-icons/md";

import { Colors } from "theme";
import EmptyState from "./EmptyState";
import { gaEvent } from "analytics/analytics";
import * as GA from "constants/analytics";
import { getData } from "store/firebase/methods";
import { useGlobal } from "store/index";

const { Title, Text } = Typography;
const { Panel } = Collapse;
const { Search } = Input;
const { Option } = Select;

const searchClient = algoliasearch(
  process.env.REACT_APP_ALGOLIA_CLIENT,
  process.env.REACT_APP_ALGOLIA_KEY
);
function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0)?.toUpperCase() + txt?.substr(1)?.toLowerCase();
  });
}

const createURL = (state) => `?${qs.stringify(state)}`;
const urlToSearchState = (location) => qs.parse(location.search.slice(1));
const searchStateToUrl = (location, searchState) =>
  searchState ? `${location.pathname}${createURL(searchState)}` : "";

const CustomPanel = ({ key, header, children, ...props }) => {
  return (
    <Panel showArrow={true} key={props.Title} header={props.Title} {...props}>
      {children}
    </Panel>
  );
};

const transformItems = (items) => {
  items = items.map((item) => {
    return { ...item, label: toTitleCase(item?.label) };
  });
  return items.sort((a, b) => {
    const labelA = a?.label;
    const labelB = b?.label;
    if (labelA < labelB) {
      return -1;
    }
    if (labelA > labelB) {
      return 1;
    }
    return 0;
  });
};

function AlgoliaFilters({
  primaryText,
  Cta,
  Hits,
  filter,
  hideCategoryFilters,
  isChecked,
  handleSelectAll,
  setIsChecked,
  checkedProducts,
  setCategory,
}) {
  const [globalState, globalActions] = useGlobal();
  const [spinning, setSpinning] = useState(false);
  const { isOnboarding, permissions, loading } = globalState;
  const isSubCatPresent = JSON.parse(localStorage.getItem("pref"))
    ? JSON.parse(localStorage.getItem("pref")).sub_category
    : false;

  const location = useLocation();
  const history = useHistory();
  const [searchState, setSearchState] = React.useState(
    urlToSearchState(location)
  );
  console.log(permissions);
  var org = localStorage.getItem("org");
  var userId = localStorage.getItem("userId");
  var isAdmin = localStorage.getItem("isAdmin");
  const orgId = JSON.parse(org)?.id;
  var defaultFilter = `manufacturer:${orgId}`;

  if ((permissions?.permissions.length > 0) & (isAdmin === "false")) {
    var check_current_user = permissions.permissions.filter(
      (el) =>
        (el?.slug === "view_products") &
        el?.subPermission?.values?.includes("current_user")
    );
    if (check_current_user.length > 0) {
      var defaultFilter = `manufacturer:${orgId} AND user_id:${userId}`;
    }
  }

  const setStateId = React.useRef();
  const DEBOUNCE_TIME = 400;
  const debouncedSetStateRef = useRef(null);

  function onSearchStateChange(updatedSearchState) {
    clearTimeout(debouncedSetStateRef.current);

    debouncedSetStateRef.current = setTimeout(() => {
      history.push(searchStateToUrl(location, updatedSearchState));
    }, DEBOUNCE_TIME);

    localStorage.setItem(
      "Cat_URL",
      searchStateToUrl(location, updatedSearchState)
    );
    setSearchState(updatedSearchState);
    localStorage.setItem("Primary_Text", primaryText);
  }

  React.useEffect(() => {
    setSearchState(urlToSearchState(location));
    localStorage.setItem(
      "Cat_URL",
      searchStateToUrl(location, urlToSearchState(location))
    );
    localStorage.setItem("Primary_Text", primaryText);
    console.log(primaryText);
  }, [location]);

  // React.useEffect(() => {
  //   const nextSearchState = urlToSearchState(location);

  //   if (JSON.stringify(searchState) !== JSON.stringify(nextSearchState)) {
  //     setSearchState(nextSearchState);
  //   }

  //   // eslint-disable-next-line
  // }, [location]);

  // function onSearchStateChange(nextSearchState) {
  //   clearTimeout(setStateId.current);
  //   setSearchState(nextSearchState);
  // }

  return (
    <>
      <InstantSearch
        searchClient={searchClient}
        indexName="products"
        searchState={searchState}
        onSearchStateChange={onSearchStateChange}
        createURL={createURL}
        refresh={true}
      >
        <Configure
          filters={filter ? `${filter} AND ${defaultFilter}` : defaultFilter}
        />
        <Row style={{ marginTop: "1.5rem" }}>
          {/* filter component */}

          <Col span={5} style={{ marginRight: "1.25rem" }}>
            <StickyBox offsetTop={70} offsetBottom={40}>
              <div
                className="filters"
                style={{
                  border: "1px solid #E6E7E7",
                  padding: "1rem",
                  minHeight: "100%",
                  borderRadius: "4px",
                }}
              >
                <Row align="middle" justify="space-between">
                  <Col>
                    <Title
                      level={4}
                      style={{
                        fontFamily: "Avenir",
                        fontSize: "16px",
                        fontWeight: "normal",
                      }}
                    >
                      Filter by
                    </Title>
                  </Col>
                  <Col>
                    <Title level={4} style={{ fontFamily: "Gilroy" }}>
                      <CustomClearRefinements />
                    </Title>
                  </Col>
                </Row>

                <Row>
                  <CustomSearchBox searchAsYouType={false} />
                </Row>
                <Row>
                  <Col
                    span={24}
                    style={{
                      background: "white",
                      marginTop: "1rem",
                    }}
                  >
                    <Collapse
                      defaultActiveKey={["Color"]}
                      expandIconPosition="left"
                      bordered={false}
                      style={{
                        backgroundColor: Colors.white,
                      }}
                    >
                      {!hideCategoryFilters && (
                        <CustomRefinementList
                          attribute="secondary_category.name"
                          limit={50}
                          filterName={"Category"}
                          facetOrdering={false}
                          transformItems={transformItems}
                        />
                      )}

                      {isSubCatPresent && (
                        <CustomRefinementList
                          attribute="sub_category"
                          limit={50}
                          filterName="Sub Category"
                          transformItems={transformItems}
                        />
                      )}

                      <CustomRefinementList
                        attribute="transformedAttributes.Color"
                        filterName="Color"
                        limit={50}
                        facetOrdering={false}
                        operator={"and"}
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Series"
                        filterName="Series"
                        limit={50}
                        facetOrdering={false}
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Material"
                        limit={50}
                        filterName="Material"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Sub Category"
                        limit={50}
                        filterName="Sub Category"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Area"
                        limit={50}
                        filterName="Area"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Area of Usage"
                        limit={50}
                        filterName="Area of Usage"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Color/Style"
                        limit={50}
                        filterName="Color/Style"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Color or Style"
                        limit={50}
                        filterName="Color or Style"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Type"
                        limit={50}
                        filterName="Type"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Country of Origin"
                        limit={50}
                        filterName="Country of Origin"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Buyer Name"
                        limit={50}
                        filterName="Buyer Name"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Country"
                        limit={50}
                        filterName="Country"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Pattern"
                        limit={50}
                        filterName="Pattern"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Size"
                        limit={50}
                        filterName="Size"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Shape"
                        limit={50}
                        filterName="Shape"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Production Technique"
                        limit={50}
                        filterName="Technique"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Construction Technique"
                        limit={50}
                        filterName="Construction Technique"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Theme"
                        limit={50}
                        filterName="Theme"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Collections"
                        filterName="Collections"
                        limit={50}
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Quality"
                        limit={50}
                        filterName="Quality"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Season"
                        limit={50}
                        filterName="Season"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Warp Material"
                        limit={50}
                        filterName="Warp Material"
                        transformItems={transformItems}
                        operator="and"
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Weft Material"
                        limit={50}
                        filterName="Weft Material"
                        transformItems={transformItems}
                        operator="and"
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Year"
                        limit={50}
                        filterName="Year"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Search keywords"
                        limit={50}
                        filterName="Keywords"
                        transformItems={transformItems}
                      />
                      <CustomRefinementList
                        attribute="transformedAttributes.Style"
                        limit={50}
                        filterName="Style"
                        transformItems={transformItems}
                      />

                      <CustomRefinementList
                        attribute="transformedAttributes.ExclusiveBuyerDetails"
                        limit={50}
                        filterName="Exclusive For"
                        transformItems={transformItems}
                      />
                    </Collapse>
                  </Col>
                </Row>
              </div>
            </StickyBox>
          </Col>

          <Col span={18}>
            <Row align="middle" justify="space-between">
              <Col span={12}>
                <Row>
                  <Title
                    level={3}
                    style={{
                      fontFamily: "Avenir",
                      fontWeight: "normal",
                      fontSize: "18px",
                    }}
                  >
                    {setCategory && (
                      <Button
                        onClick={() => {
                          history.push(`/master-catalogue/${"2"}`);
                        }}
                        style={{
                          border: "none",
                          padding: 0,
                          margin: 0,
                          align: "center",
                        }}
                      >
                        <LeftOutlined
                          style={{
                            fontSize: 20,
                            fontWeight: "bold",
                            paddingRight: "12px",
                          }}
                        />
                      </Button>
                    )}
                    {primaryText}
                  </Title>
                </Row>
              </Col>
              <Col span={12}>
                <Row justify="end">
                  <Space>
                    {/* select all checkbox starts here */}
                    <CustomSelectAll
                      isChecked={isChecked}
                      primaryText={primaryText}
                      handleSelectAll={handleSelectAll}
                      checkedProducts={checkedProducts}
                      setIsChecked={setIsChecked}
                    />
                    {/* select all checkbox ends here */}
                    <CustomSortBy
                      defaultRefinement="products_id_desc"
                      items={[
                        {
                          value: "products",
                          label: "Best match",
                        },
                        {
                          value: "products_desc",
                          label: "Recent first",
                        },
                        {
                          value: "products_asc",
                          label: "Oldest first",
                        },
                        {
                          value: "products_id_asc",
                          label: "Product ID Asc",
                        },
                        {
                          value: "products_id_desc",
                          label: "Product ID Desc",
                        },
                      ]}
                    />
                    {Cta && Cta}
                  </Space>
                </Row>
              </Col>
            </Row>
            <ScrollTo>
              <Row>
                <Space direction="vertical">
                  <CustomStats />

                  <Row align="top">
                    {" "}
                    <CustomCurrentRefinements />{" "}
                  </Row>
                </Space>
              </Row>
              <Row>
                <Col span={24}>
                  <EmptyState Results={Hits} Cta={Cta} />

                  <Pagination
                    translations={{
                      // previous:  <MdKeyboardArrowLeft style={{fontSize:18,}}/>,
                      // next: <MdKeyboardArrowRight style={{fontSize:18}} />,
                      previous: (
                        <span onClick={() => setIsChecked(false)}>
                          {"Previous"}
                        </span>
                      ),
                      next: (
                        <span
                          onClick={() => {
                            setIsChecked(false);
                          }}
                        >
                          {"Next"}
                        </span>
                      ),
                      first: (
                        <span onClick={() => setIsChecked(false)}>{"«"}</span>
                      ),
                      last: (
                        <span onClick={() => setIsChecked(false)}>{"»"}</span>
                      ),
                      page: (currentRefinement) => {
                        return (
                          <span
                            onClick={() => {
                              setIsChecked(false);
                            }}
                          >
                            {currentRefinement}
                          </span>
                        );
                      },
                      ariaPrevious: "Previous page",
                      ariaNext: "Next page",
                      ariaFirst: "First page",
                      ariaLast: "Last page",
                      ariaPage(currentRefinement) {
                        return `Page ${currentRefinement}`;
                      },
                    }}
                    showLast={true}
                    showFirst={true}
                    padding={5}
                    onClick={() => alert("clicked")}
                  />
                </Col>
              </Row>
            </ScrollTo>
          </Col>
        </Row>
      </InstantSearch>
    </>
  );
}

const DropdownRefinementList = ({
  items,
  isFromSearch,
  refine,
  searchForItems,
  createURL,
  filterName,
  ...props
}) => {
  const [showSearch, setShowSearch] = useState(false);
  const handleSearch = (event) => {
    searchForItems(event.currentTarget.value);
  };
  const SEARCH_STYLES = {
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    float: "right",
    width: "87%",
  };
  const ICON_STYLE = {
    background: "lightgrey",
    borderRadius: "50%",
    padding: 5,
    fontSize: 18,
    marginLeft: "1rem",
  };
  const FIELD_STYLE = { marginLeft: 0, fontSize: "16px" };
  const Title = (
    <div style={SEARCH_STYLES}>
      <Typography.Title style={FIELD_STYLE} level={5}>
        {" "}
        {`${filterName}`}
      </Typography.Title>
    </div>
  );

  const Search = (
    <div style={SEARCH_STYLES} onClick={(e) => e.stopPropagation()}>
      <Input
        style={FIELD_STYLE}
        type="search"
        onChange={(event) => handleSearch(event)}
        placeholder={`Search for ${filterName}`}
        onClick={() => {
          gaEvent(
            GA.EVENT.CLICK,
            GA.CATEGORY.ALGOLIA,
            GA.DESCRIPTION.ALGOLIA_SEARCH
          );
        }}
      />
      <CloseOutlined
        style={ICON_STYLE}
        onClick={() => {
          setShowSearch(false);
          gaEvent(
            GA.EVENT.CLICK,
            GA.CATEGORY.ALGOLIA,
            GA.DESCRIPTION.ALGOLIA_CLOSE_SEARCH
          );
        }}
      />
    </div>
  );

  const header = {
    showSearch,
    setShowSearch,
    Title,
    Search,
  };
  props = { ...header, ...props };
  return (
    (items.length > 0 || isFromSearch) && (
      <CustomPanel {...header} {...props}>
        <Row>
          <Space direction="vertical" size="small" style={{ marginTop: 0 }}>
            {items.map((item) => (
              <Checkbox
                key={item.label}
                checked={item.isRefined}
                onClick={(event) => {
                  event.preventDefault();
                  refine(item.value);
                  gaEvent(
                    GA.EVENT.CLICK,
                    GA.CATEGORY.ALGOLIA,
                    GA.DESCRIPTION.ALGOLIA_FILTER_CHECKED
                  );
                }}
              >
                <Typography.Text
                  style={{
                    fontSize: "14px",
                    color: Colors.neutral,
                    font: "Roboto",
                  }}
                >
                  {isFromSearch ? (
                    <Highlight attribute="label" hit={item} />
                  ) : (
                    item.label
                  )}{" "}
                  <Text
                    type="secondary"
                    style={{
                      marginTop: -10,
                      color: Colors.neutral,
                      font: "Roboto",
                    }}
                  >
                    ({item.count})
                  </Text>
                </Typography.Text>
              </Checkbox>
            ))}
          </Space>
        </Row>
      </CustomPanel>
    )
  );
};

const CurrentRefinements = ({ items, refine }) => (
  <Space direction="horizontal" wrap={true} align="baseline">
    {items.map((item) =>
      item.items.map((nested, index) => (
        <span
          onClick={(event) => {
            event.preventDefault();
            refine(nested.value);
          }}
        >
          <Badge
            key={index}
            count={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "row",
                  background: Colors.primaryColorTint,
                  padding: 10,
                  borderRadius: "16px",
                  color: Colors.primaryColor,
                }}
              >
                <Text
                  style={{
                    color: Colors.primaryColor,
                    fontSize: 16,
                  }}
                >
                  {nested.label}{" "}
                </Text>
                <CloseOutlined
                  style={{
                    color: Colors.primaryColor,
                    cursor: "pointer",
                    fontSize: 16,
                  }}
                />
              </div>
            }
          />
        </span>
      ))
    )}
    <Title level={3} style={{ fontFamily: "Gilroy", padding: "0px" }}>
      <CustomClearRefinements />
    </Title>
  </Space>
);

const ClearRefinements = ({ items, refine }) =>
  items?.length > 0 && (
    <Button
      type="link"
      size="large"
      onClick={() => {
        refine(items);
        gaEvent(
          GA.EVENT.CLICK,
          GA.CATEGORY.ALGOLIA,
          GA.DESCRIPTION.ALGOLIA_CLEAR_ALL_BUTTON
        );
      }}
      disabled={!items.length}
      style={{ color: Colors.gray }}
    >
      Clear all
    </Button>
  );

const SearchBoxx = ({ currentRefinement, refine, isSearchStalled }) => (
  <Search
    type="search"
    size="large"
    defaultValue={currentRefinement}
    placeholder="Search for products"
    onSearch={(value, event) => refine(value)}
    onClick={() => {
      gaEvent(
        GA.EVENT.CLICK,
        GA.CATEGORY.ALGOLIA,
        GA.DESCRIPTION.ALGOLIA_SEARCH
      );
    }}
  />
);

const Stats = ({ nbHits }) => (
  <Text type="secondary" style={{ marginTop: -10 }}>
    {nbHits === 1 ? `${nbHits} Product` : `${nbHits} Products`}
  </Text>
);

const SortBy = ({ items, currentRefinement, refine }) => {
  return (
    <div>
      <Space align="center">
        <MdSort size={27} />
        <Title level={5} style={{ paddingBottom: 0 }}>
          Sort by
        </Title>
        <Select
          defaultValue={currentRefinement}
          style={{ width: 200 }}
          onChange={(event) => {
            refine(event);
          }}
          onClick={() => {
            gaEvent(
              GA.EVENT.CLICK,
              GA.CATEGORY.ALGOLIA,
              GA.DESCRIPTION.ALGOLIA_SELECT_SORTBY
            );
          }}
        >
          {items.map((item) => (
            <Option key={`${item.value}_${item.index}`} value={item.value}>
              {item.label}
            </Option>
          ))}
        </Select>
      </Space>
    </div>
  );
};
const SelectAll = ({
  hits,
  primaryText,
  isChecked,
  handleSelectAll,
  checkedProducts,
  setIsChecked,
}) => {
  useEffect(() => {
    if (checkedProducts && hits) {
      const hitsIds = hits.map((hit) => hit.id);
      const checkedIds = checkedProducts.map((product) => product.id);
      const isChecked = hitsIds.every((id) => checkedIds.includes(id));

      if (isChecked) {
        setIsChecked(isChecked);
      } else {
        setIsChecked(false);
      }
    }
  }, [checkedProducts, hits]);
  return (
    <>
      {primaryText === "Select products for the catalogue" ? (
        <Checkbox checked={isChecked} onClick={() => handleSelectAll(hits)}>
          <Title level={5} style={{ paddingBottom: 0 }}>
            Select All
          </Title>
        </Checkbox>
      ) : null}
    </>
  );
};

const CustomSelectAll = connectHits(SelectAll);
const CustomStats = connectStats(Stats);
const CustomSearchBox = connectSearchBox(SearchBoxx);
const CustomSortBy = connectSortBy(SortBy);
const CustomRefinementList = connectRefinementList(DropdownRefinementList);
const CustomCurrentRefinements = connectCurrentRefinements(CurrentRefinements);
const CustomClearRefinements = connectCurrentRefinements(ClearRefinements);

export default AlgoliaFilters;
